import { EntityDetail } from '@/common/entityFramework/entityDetail/EntityDetail';
import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm';
import { EntitySelect } from '@/common/form/formFields/EntitySelect';
import { ValList } from '@/common/val/ValList';
import { McdDispList } from '@/sc/entities/mcdDisp/McdDispList';
import { useEntityMgr } from '../../../common/entityFramework/entityView/EntityMgrContext';

export const McdInvLineDetail = () => {
  const { entityObj } = useEntityMgr();

  const augMcdInvFieldDefs = (fieldToFieldDef) => {
    fieldToFieldDef.code.component = <EntitySelect key="code" fieldDef={fieldToFieldDef.code} />;
  };

  const tabSpecs = [
    { id: 'info', label: 'Info', content: <EntityForm /> },
    {
      id: 'inv',
      label: 'Invoice',
      content: <EntityForm entity="MCD_INV" entityId={entityObj.mcdInvId} augFieldDefs={augMcdInvFieldDefs} />,
    },
    { id: 'disps', label: 'Disputes', content: <McdDispList mcdInvLineId={entityObj.id} /> },
    {
      id: 'validations',
      label: 'Validations',
      content: <ValList parentEntity="MCD_INV_LINE" parentEntityId={entityObj.id} />,
    },
  ];

  return <EntityDetail tabSpecs={tabSpecs} />;
};
